import React from "react";

function HomeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 20 21"
    >
      <path
        fill="currentColor"
        d="M1 12.486h2v7a1 1 0 001 1h12a1 1 0 001-1v-7h2a.998.998 0 00.743-1.67l-9-10c-.38-.421-1.107-.421-1.486 0l-9 10A1 1 0 001 12.486zm5.949-.317c.03.095.813 2.316 3.05 2.316 2.27 0 3.043-2.287 3.05-2.31l1.9.62c-.048.152-1.246 3.69-4.95 3.69-3.702 0-4.9-3.538-4.95-3.688l1.9-.628z"
      ></path>
    </svg>
  );
}

export default HomeIcon;
